import { createSelector } from 'selectors'

import { constant } from './constant'

const { selector } = constant

const getTargets = () => createSelector<NodeListOf<HTMLElement>>({ selector: `.${selector.target}` }, true)

const getFilter = () => createSelector<HTMLElement>({ selector: `.${selector.filter}` })

export const selectors = {
	getTargets,
	getFilter,
}
